import { backUrl } from "../utils/backURL";
import { withAuthCredentials } from "../utils/authFetchOptions";

export const getMantisAgents = async (token) => {
  try {
    const response = await fetch(`${backUrl}/mantis-agents`, withAuthCredentials({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }));

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching mantis agents:", error);
    throw error;
  }
};

export const getMantisAgentsWithDecryptedData = async (token) => {
  try {
    const response = await fetch(`${backUrl}/mantis-agents/decrypted`, withAuthCredentials({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }));

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching mantis agents with decrypted data:", error);
    throw error;
  }
};

export const getMantisAgentsWithDecryptedDataByBusinessId = async (
  token,
  businessId
) => {
  try {
    const response = await fetch(
      `${backUrl}/mantis-agents/business/${businessId}/decrypted`,
      withAuthCredentials({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(
      "Error fetching mantis agents by business with decrypted data:",
      error
    );
    throw error;
  }
};

export const getAgentSessions = async (token, params = {}) => {
  try {
    const qs = new URLSearchParams();
    if (params.page != null) qs.set("page", String(params.page));
    if (params.pageSize != null) qs.set("pageSize", String(params.pageSize));
    if (params.businessName) qs.set("businessName", String(params.businessName));
    if (params.agentName) qs.set("agentName", String(params.agentName));
    if (params.status) qs.set("status", String(params.status));
    const q = qs.toString();
    const url = `${backUrl}/agent-sessions${q ? `?${q}` : ""}`;
    const response = await fetch(url, withAuthCredentials({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }));

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching agent sessions:", error);
    return { success: false, error: error.message };
  }
};
